document.addEventListener('alpine:init', () => {
  Alpine.data('pupIgDataEnd', () => ({

    _supabase: null,
    email: '',
    originalUrl: '',
    pupName: '',
    sunflower_glasses_watermarked: null,
    sunflower_glasses_clean: null,
    selectedVariant: '',
    photoLand: window.pupIgStrings.photoLand,
    step: 1,
    variants: [
      { id: 1, emoji: '🐾', label: window.pupIgStrings.variant1_label },
      { id: 2, emoji: '🎄', label: window.pupIgStrings.variant2_label },
      { id: 3, emoji: '🌸', label: window.pupIgStrings.variant3_label },
    ],

    init() {
        const url = 'https://shmjvbgnblpwrsghxjpr.supabase.co'
        const key = 'sb_publishable_z9frF4Yd8QxAC19Lonpg7g_mSDAHBPT'
        this._supabase = supabase.createClient(url, key);
    },

    async findPup() {
      const emailToSearch = this.email.trim().toLowerCase();

      try {
        const { data, error } = await this._supabase
          .from('users')
          .select('dog_name, generated_url, generated_door_b_url_watermarked, generated_door_b_url_clean')
          .eq('email', emailToSearch)
          .maybeSingle();

        if (error) throw error;

        if (data) {
          this.pupName = data.dog_name;
          this.originalUrl = data.generated_url;
          this.sunflower_glasses_watermarked = data.generated_door_b_url_watermarked;
          this.variants[0].watermarked = this.sunflower_glasses_watermarked
          this.sunflower_glasses_clean = data.generated_door_b_url_clean;
          this.variants[0].image = this.sunflower_glasses_clean
          this.step = 2
          this.pingGen()
        } else {
          alert('No pup found!')
        }

      } catch (err) {
        console.error('Supabase Fetch Error:', err);
      }
    },
    pingGen() {
      fetch('https://sharkadoodle-style-face-only-8256783-v73.app.beam.cloud/ping', {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer wclFmmq7FMXAh1Qoi___OsXJyAd7u0B5wL4EbY-z0gbS33YR_cFNVXOOBY7NVzEcY59uTGRD5AtZsvgbUbzUTw==',
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('Success:', data);
    })
    .catch(error => {
      console.error('Error:', error);
    });
   },

    async getBase64(fileUrl) {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch URL: ${response.statusText}`);
      }
      file = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },

   async generateOld() {
      this.step = 4;
    this.errorMessage = '';
    
    // https://sharkadoodle-style-face-only-8256783-v52.app.beam.cloud/generate
    // https://api.mockfly.dev/mocks/5f002a10-bd0b-4acd-b384-90e5a0b8191c/generate
    const url = 'https://sharkadoodle-beam-wake.sharkadoodle-wake.workers.dev/face';
    const token = 'wclFmmq7FMXAh1Qoi___OsXJyAd7u0B5wL4EbY-z0gbS33YR_cFNVXOOBY7NVzEcY59uTGRD5AtZsvgbUbzUTw==';
    const base64Image = await this.getBase64(this.originalUrl);
   
    const payload = {
        email: this.email,
        encoded_images: [
            base64Image
        ]
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        
        const apiData = await response.json();
        
        if (apiData && apiData.images) {
            // Loop through the incoming API images
            apiData.images.forEach((item, index) => {
                // Check if an object already exists at this index in your Alpine array
                if (this.variants[index]) {
                    // Update only the image and watermarked properties directly
                    this.variants[index].image = item.original;
                    this.variants[index].watermarked = item.watermarked;
                }
            });
        }

    } catch (error) {
        this.errorMessage = 'Failed to update variants.';
        console.error(error);
    } finally {
      // this.percent = 100;
      this.generating = false;
    }
    },

    async finish(productId){
      const formData = {
            'items': [{
                'id': productId,
                'quantity': 1,
                'properties': {
                  'aiImage': this.sunflower_glasses_clean,
                  'numberOfDogs': 1
                }
            }]
        }
      
        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });
            const responseData = await response.json();

            // console.log(`Successfully added image ${Image} to the cart.`);
        } catch (error) {
          window.test = error
            console.error(`Error adding image ${Image}:`, error);
        }

        window.location = '/cart';
    },


    dotClass(n) {
      if (n < this.step)   return 'pup-dot pup-dot--done';
      if (n === this.step) return 'pup-dot pup-dot--active';
      return                      'pup-dot pup-dot--future';
    },
    lineClass(n) {
      return n < this.step ? 'pup-line pup-line--done' : 'pup-line pup-line--future';
    },
  
    //Loader
    percent: 30, 
    radius: 40,
    get circumference() { return 2 * Math.PI * this.radius },
    get strokeDashoffset() { return this.circumference - (this.percent / 100) * this.circumference },
    get isComplete() { return this.percent >= 100 },
    startLoader() {
      // Clear any existing interval just in case
      clearInterval(this.intervalId);
      
      this.intervalId = setInterval(() => {
        if (this.percent < 100) {
          this.percent++;
        } else {
          clearInterval(this.intervalId);
        }
      }, 100); } // 400ms * 100 steps = 40,000ms (40 seconds)
  })
  )}
)